import { render, staticRenderFns } from "./ControleEstoque.vue?vue&type=template&id=db65131e&scoped=true&"
import script from "./ControleEstoque.vue?vue&type=script&lang=js&"
export * from "./ControleEstoque.vue?vue&type=script&lang=js&"
import style0 from "./ControleEstoque.vue?vue&type=style&index=0&id=db65131e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db65131e",
  null
  
)

export default component.exports